module.exports = __webpack_public_path__ + "img/bg-2@1000x-80-min.bffbcee9.webp";